import React, { useEffect, useState } from "react";

const API_ACTIVITY_EVENT = "hrm-api-activity";

export default function NetworkStatus() {
  const [online, setOnline] = useState(() => navigator.onLine);
  const [slowRequests, setSlowRequests] = useState(0);

  useEffect(() => {
    const handleOnline = () => setOnline(true);
    const handleOffline = () => setOnline(false);
    const handleActivity = (event) => setSlowRequests(event?.detail?.slowRequests || 0);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
    window.addEventListener(API_ACTIVITY_EVENT, handleActivity);
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener(API_ACTIVITY_EVENT, handleActivity);
    };
  }, []);

  if (online && slowRequests === 0) return null;

  return (
    <div className={`fixed inset-x-3 top-3 z-[500] mx-auto max-w-xl rounded-2xl border px-4 py-3 text-center text-xs font-black shadow-xl backdrop-blur-md ${online ? "border-amber-200 bg-amber-50/95 text-amber-700" : "border-rose-200 bg-rose-50/95 text-rose-700"}`} role="status" aria-live="polite">
      {online
        ? "Internet is slow. Your request is still processing - please do not submit again."
        : "You are offline. Reconnect to the internet, then use Retry where available."}
    </div>
  );
}

export { API_ACTIVITY_EVENT };
